module.exports = __webpack_public_path__ + "dist/images/4c2338fe1daf075f6b6b665174f86287.gif";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/pobble-user/school.gif
// module id = 470
// module chunks = 0